<template>
    <div
        class="ui-toggle__wrapper"
        :class="{ 'ui-toggle__wrapper_disabled': disabled }"
        @click="toggle"
    >
        <div
            class="ui-toggle"
            :class="{ 'ui-toggle_active': modelValue, 'ui-toggle_disabled': disabled }"
        >
            <div class="ui-toggle__circle"></div>
        </div>

        <div
            class="ui-toggle__label"
            :class="{ 'ui-toggle__label_disabled': disabled }"
        >
            <slot>{{ label }}</slot>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { defineProps, defineEmits } from 'vue';

    const props = defineProps({
        modelValue: {
            type: Boolean,
            required: true,
        },
        label: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    });

    const emit = defineEmits<{
        (e: 'update:modelValue', value: boolean): void,
    }>();

    function toggle(): void {
        if (!props.disabled) {
            emit('update:modelValue', !props.modelValue);
        }
    }
</script>

<style lang="scss" scoped>
    @use './UIToggle.scss' as *;
</style>
